import { CapgoIntercom } from '@capgo/capacitor-intercom';
import { isNativeApp } from 'helpers';
import { authTypes } from 'redux/auth';

const closeIntercom = () => {
  // Web (uppercase Intercom)
  if (window.Intercom) {
    window.Intercom('shutdown');
  }

  if (isNativeApp) {
    CapgoIntercom.logout();
  }
};

export default () => next => action => {

  const { type } = action;

  switch (type) {
    case authTypes.logoutSuccess:
      closeIntercom();
      break;
    default:
      break;
  }

  next(action);
};
